import {
  DocumentDTO,
  IntlCategoryDTO,
  IntlCategoryEntity,
  IntlSubcategoryDTO,
  IntlSubtitleDTO,
} from '@/services/content-api-types';

import { countries, type Country } from './countries';

import { stateAtom } from '@/atoms';

type ConfirmationModalTypes =
  | 'categoryVisibility'
  | 'categoryDelete'
  | 'subcategoryVisibility'
  | 'subcategoryDelete'
  | 'sectionVisibility'
  | 'sectionDelete'
  | 'documentVisibility'
  | 'documentDelete';

const getDefaultSelectedCountry = (): Country => {
  const defaultCountry = countries[0];

  if (!defaultCountry) {
    throw new Error('Admin countries must include at least one country');
  }

  return defaultCountry;
};

export const {
  atom: adminStateAtom,
  focusState: focusAdminState,
  getState: getAdminState,
  setState: setAdminState,
  useState: useAdminState,
  useFocusState: useFocusAdminState,
} = stateAtom({
  selectedCountry: getDefaultSelectedCountry(),
  editingCategory: undefined as IntlCategoryEntity | undefined,
  deleteModalState: {
    open: false,
    isFeatured: false,
    category: undefined as IntlCategoryEntity | undefined,
  },
  visibilityModalState: {
    open: false,
    isFeatured: false,
    category: undefined as IntlCategoryEntity | undefined,
    categoryIndex: undefined as number | undefined,
  },
  addRecommendedCategoryOpen: false,
  addCategoryOpen: false,
  temporaryCategory: {
    id: '',
    displayIndex: 0,
    enabled: false,
    featured: false,
    name: { en: '', es: '' },
    icon: '',
    subcategories: [],
  } as IntlCategoryDTO,
  selectedSubcategoryId: undefined as undefined | string,
  selectedSubcategoryIndex: -1,
  selectedSubcategory: null as IntlSubcategoryDTO | null,
  selectedSubtitleIndex: -1,
  selectedSubtitle: null as IntlSubtitleDTO | null,
  selectedDocumentIndex: -1,
  selectedDocument: null as DocumentDTO | null,
  confirmationModalType: null as ConfirmationModalTypes | null,
  showAddProcedurePopUp: false,
  isEditingSection: false,
  documentIsVisibleInSubtitle: false,
});
